'use strict';

/**
 * @ngdoc function
 * @name 360StoreAngularApp.controller:AdminCtrl
 * @description
 * # AdminCtrl
 * Controller of the 360StoreAngularApp
 */
angular.module('360StoreAngularApp')
	.controller('AdminCtrl', function ($scope, $location, $uibModal, Analytics, BUILD_DATE, BASE_URL, api, session, user) { // FIX!! $location stuff is all broken. Much of the api call stuff is broken. Use the legacy site for now.
		$scope.user = user;
		$scope.vm = this;
		$scope.search = $location.search();
		$scope.today = new Date().toLocaleDateString('sv-SE');
		$scope.aff = {
			dateFrom: window.moment().startOf('quarter').format('YYYY-MM-DD'),
			dateTo: window.moment().endOf('quarter').format('YYYY-MM-DD')
		};
		$scope.sortModelUsers = {};
		$scope.sortModelPromos = {};
		$scope.sortModelProducts = {};
		$scope.sortModel = {};
		$scope.reportFilter = {
			dateFrom: window.moment().startOf('month').format('YYYY-MM-DD'),
			dateTo: window.moment().endOf('month').format('YYYY-MM-DD')
		};
		$scope.baseUrl = BASE_URL;
		/**
		 * @type {ProductLine[]}
		 */
		$scope.products = [];

		/**
		 * @type {ValueListItem[]}
		 */
		$scope.keyGeneratorOptions = [
			{value: 'com.prosc.store.model.license.AddOnLicenseKeyGenerator', name: 'AddOn'},
			{value: 'com.prosc.store.model.license.DefaultLicenseKeyGenerator', name: 'Default (explicit)'}, // not the same as empty: a $0 product with an empty override falls back to Free, which emits no key
			{value: 'com.prosc.store.model.license.FreeLicenseKeyGenerator', name: 'Free'},
			{value: 'com.prosc.store.model.license.HiddenLicenseKeyGenerator', name: 'Hidden'},
			{value: 'com.prosc.store.model.license.SuperContainerHostingLicenseKeyGenerator', name: 'SuperContainer Hosting'},
		];

		/**
		 * @param variantType {VariantType}
		 */
		$scope.iconForVariantType = (variantType) => {
			switch (variantType.code || '') {
				case 'DEMO':
					return 'fa-cloud-download';
				case 'RENEWAL':
					return 'fa-refresh';
				case 'SINGLE_USER':
					return 'fa-user';
				case 'DEFAULT':
					return 'fa-users';
				case 'ENTERPRISE':
					return 'fa-building';
				case 'DEVELOPER_ENTERPRISE':
					return 'fa-globe';
				case 'DEVELOPER':
					return 'fa-suitcase';
				case 'ADD_DEVICES':
					return 'fa-laptop';
				case 'ADD_SOLUTIONS':
					return 'fa-plus-circle';
				default:
					return 'fa-question-circle';
			}
		};

		const apiGet = function (url, params, successCallback) {
			return api.get('api/admin/' + url, {params: params}).then(successCallback);
		};

		$scope.apiGet = apiGet;

		$scope.didSelectTab = function (whichTab) {
			if (whichTab === 'home' && !$location.search().tab) {
				return; // don't set the tab
			}
			$location.search('tab', '' + whichTab);
		};

		const showTab = function (index) {
			$scope.active = index;
			$location.search('tab', '' + index);
		};

		$scope.userSearch = function (q) {
			if (q) {
				$location.search('userQuery', q);
				apiGet('userSearch', {q: q}, function (response) {
					$scope.users = response;
				});
			}
		};

		$scope.userFetchOrders = function (u) {
			apiGet('orders', {email: u.email, registeredTo: u.company, logicalOperator: 'OR'}, function (response) {
				$scope.orders = response;
				showTab('orders');
			});
		};

		$scope.userFetchLinkedLicenses = function (u) {
			apiGet('orders', {accountId: u.id}, function (response) {
				$scope.orders = response;
				showTab('orders');
			});
		};

		$scope.userSwitchUser = async function (u) {
			await session.switchUser({userId: u.id})
			$location.path('/my-licenses')
		};

		$scope.orderSwitchUser = async function (/*ShoppingCart*/ o) {
			const u = await api.adminFetchUserByEmail(o.paymentDatas[0].person.email);
			await session.switchUser({userId: u.id})
			$location.path('/my-licenses')
		};

		$scope.updatePaymentInfo = async (/*ShoppingCart*/ o) => {
			const licenseKey = await api.generateLicenseKeyForOrderId(o.id);
			$location.path('/update-payment-info/' + licenseKey);
		};

		function setSelectedCart(cart) {
			$scope.selectedCart = cart;
			if (cart) {
				$location.search('selectedCartId', cart?.id);
			}
		}

		$scope.orderRenewModal = async function (/*ShoppingCart*/ o) {
			setSelectedCart(o);
			try {
				await $uibModal.open({
					controller: 'OrderRenewCtrl',
					scope: $scope,
					templateUrl: 'views/modal-order-renew.html?v=' + BUILD_DATE,
					size: 'med',
					resolve: {
						orderAndRenewPreview: apiGet('renew-preview', {orderId: o.id}),
						isAdmin: true,
					}
				}).result; // cancel will throw exception here
				let newCart = await api.adminRenewProcess(o);
				toastr.success('Order #' + o.id + ' was successfully renewed by order #' + newCart.id, 'Renewal Successful');
			} finally {
				$scope.$root.$broadcast('refresh-admin-orders'); // whether success or failure, show the updated status
			}
		};

		$scope.orderSearch = function (q) {
			$location.search('orderQuery', q);
			$scope.activeTab = 'orders';
			if (q) {
				apiGet('orders', {q: q}, function (response) {
					$scope.orders = response;
					if ($scope.orders.length === 0) {
						window.toastr.warning('No matching orders found', 'Empty Results', {timeOut: 1000});
					}
					if ($scope.orders.length === 1) {
						// $scope.orderEdit($scope.orders[0]);
					} else if ($location.search().selectedCartId) {
						let selectedCartId = parseInt($location.search().selectedCartId);
						setSelectedCart($scope.orders.find(o => o.id === selectedCartId));
					}
				});
			}
		};

		/**
		 * @param o {ShoppingCart}
		 */
		const _orderEdit = async function (o) {
			return $scope.$root.editOrderModal(o);
		};

		/**
		 * @param {ShoppingCart} cart
		 */
		$scope.orderEdit = function (cart) {
			let orderId = cart?.id;
			if (!orderId) {
				throw 'Order ID not specified';
			}
			setSelectedCart(cart);
			apiGet('orders', {cartId: orderId}, async function (response) {
				let saved = await _orderEdit(response[0]);
				if ( saved?.id && saved.id === cart?.id) { // only if we didn't navigate to a different order
					angular.copy(saved, cart);
				}
			});
		};

		$scope.orderEditCartItemId = function (cartItemId) {
			if (!cartItemId) {
				throw 'cartItemId not specified';
			}
			apiGet('orders', {cartItemId: cartItemId}, function (response) {
				_orderEdit(response[0]);
			});
		};

		$scope.affiliateQuery = function (params) {
			apiGet('affiliate-orders', params, function (response) {
				if (response.length === 0) {
					toastr.warning('No matching records found');
				}
				$scope.affiliateOrders = response;
				const payouts = {};
				$scope.affiliateOrders.forEach(function (x) {
					const affiliate = x.promo_code_name;
					const amount = x.extended_price_stored_before_promo - x.extended_price_stored;
					payouts[affiliate] = (payouts[affiliate] || 0) + amount;
				});
				$scope.affiliatePayouts = payouts;
			});
		};

		$scope.editProduct = function (product) {
			$scope.selectedProduct = product;
			return $uibModal.open({
				controller: 'ModalProductEditCtrl',
				scope: $scope,
				templateUrl: 'views/modal-product-edit.html?v=' + BUILD_DATE,
				size: 'lg',
				resolve: {
					product: product.id ? apiGet('product', {id: product.id}) : product
				}
			}).result
				.then(function (updated) {
					angular.copy(updated, product);
					return updated;
				});
		};

		$scope.productAdd = () => $scope.editProduct({versions: [{versionNumber: 1, name: '1.0', variants: []}]})
			.then(saved => {
				$scope.productsAll.push(saved);
				$scope.products.push(saved);
			});

		$scope.productFetchCsv = function (/*product*/) {
			window.alert('Not implemented yet'); // FIX!!!!
			// window.location.href = '../API/productEmailCsv?id=' + product.id;
		};

		$scope.productAddUser = function (/*product*/) {
			window.alert('Not implemented yet'); // FIX!!!!
			// $scope.userToAdd = window.prompt('Enter a Full Name <email@domain.com> to add to the product email list.', $scope.userToAdd || '');
			// if ($scope.userToAdd) {
			// 	apiGet('productAddUser', {productCode: product.code, email: $scope.userToAdd}, function () {
			// 		window.alert($scope.userToAdd + ' has been added to ' + product.name);
			// 		$scope.userToAdd = null;
			// 	});
			// }
		};

		function runReport(reportName, filter) {
			$scope.reportData = null;
			$scope.apiGet(reportName, filter, function (response) {
				$scope.reportData = response;
				if (response.length === 0) {
					window.alert('No records found in this date range');
				}
			});
		}

		$scope.renewalReport = function (filter) {
			runReport('renewal-report', filter);
		};

		$scope.affiliateSignupReport = function (filter) {
			runReport('affiliate-signup-report', filter);
		};

		/*
		///////////////////////////////////////////////////////////////////////////
		// PROMO CODES
		///////////////////////////////////////////////////////////////////////////
		*/
		$scope.promoSearch = function (q) {
			$location.search('promoQuery', q);
			apiGet('promo-codes', {q: q})
				.then(function (found) {
					$scope.promos = found;
				});
		};

		$scope.promoDescription = function (promo) {
			if (promo.creditAmount) {
				return '$' + promo.creditAmount;
			} else if (promo.creditPercent) {
				return promo.creditPercent + '%';
			} else {
				return '???';
			}
		};

		$scope.promoAccountDescription = function (promo) {
			if (promo.account) {
				return promo.account.name;
			} else if (promo.company) {
				return promo.company;
			} else {
				return null;
			}
		};

		$scope.promoFetchOrders = function (p) {
			$scope.orderSearch('promoCode:' + p.code);
		};

		$scope.promoEdit = function (o) {
			$scope.selectedPromo = o;
			$uibModal.open({
				controller: 'PromoEditCtrl',
				scope: $scope,
				templateUrl: 'promoEdit.html', // no BUILD_DATE param, this template is embedded as a text/ng-template
				size: 'md',
				resolve: {
					promo: o
				}
			});
		};

		$scope.promoAdd = function () {
			$scope.promoEdit({discountOnReport: true});
		};


		/*
		///////////////////////////////////////////////////////////////////////////
		// INIT
		///////////////////////////////////////////////////////////////////////////
		*/
		const refreshCurrentTab = function () {
			const search = $location.search();
			if (search.userQuery && $scope.activeTab === 'users') {
				$scope.userSearch(search.userQuery);
			}
			if (search.orderQuery && $scope.activeTab === 'orders') {
				$scope.orderSearch(search.orderQuery);
			}
			if (search.promoQuery && $scope.activeTab === 'promos') {
				$scope.promoSearch(search.promoQuery);
			}
		};

		if ($scope.search.tab) {
			$scope.activeTab = $scope.search.tab || 0; // which tab
		}

		refreshCurrentTab();
		$scope.$on('refresh-admin-orders', () => refreshCurrentTab());

		// listen for back/forward button
		$scope.$on('$routeUpdate', function () {
			const search = $location.search();
			$scope.search = search;
			$scope.activeTab = search.tab || 'home';
			if (search.refresh === 'true') {
				$location.search('refresh', null);
				refreshCurrentTab();
			}
		});

		apiGet('products', null, function (response) {
			const cutoff = Date.now() - 86400000 * 30;
			$scope.productsAll = response;
			$scope.products = response.filter(p => p.featuredBoolean || p.dateCreated > cutoff || p.dateModified > cutoff);
		});

	})
	.controller('OrderEditCtrl', function ($scope, $location, $uibModal, api, session, BASE_URL, BUILD_DATE, BILLING_PERIODS, storeUtils, order, user) {
		$scope.BASE_URL = BASE_URL;
		$scope.originalOrder = order;
		$scope.order = angular.copy(order);
		$scope.products = [];
		/**
		 * @type {EmailLog[]}
		 */
		$scope.emails = undefined;
		/**
		 * @type {Object[]}
		 */
		$scope.licenseCheckActitivies = undefined;

		/**
		 * @type {VariantType[]}
		 */
		$scope.variantTypes = [];
		/**
		 * @type {VariantType[]}
		 */
		$scope.variantTypesExcludingDups = [];

		$scope.tmp = {isSupportNotesCollapsed: false};

		/**
		 * The first subscription line. Only those carry a billingPeriod here (see AdminOrdersServlet): the current plan
		 * of the license they belong to, kept on its support records. An order with no subscription line shows none.
		 * @return {CartItem|undefined}
		 */
		$scope.billingPeriodLine = () => ($scope.order.cartItems || []).find(ci => ci.billingPeriod);

		/**
		 * @return {string|undefined} "Monthly" or "Yearly", or nothing when this order has no subscription
		 */
		$scope.billingPeriodLabel = () => BILLING_PERIODS.find(o => o.id === $scope.billingPeriodLine()?.billingPeriod)?.label;

		/**
		 * Opens the my-licenses billing period picker for this order's license, then reloads the order: the server
		 * appends a note to each support record, which a later Save would otherwise overwrite with the stale notes.
		 */
		$scope.changeBillingPeriod = function () {
			const ci = $scope.billingPeriodLine();
			const maxReleaseDate = (ci.supports || []).map(s => s.maxReleaseDate).filter(Boolean).sort().pop();
			$uibModal.open({
				templateUrl: 'views/modal-change-billing-period.html?v=' + BUILD_DATE,
				controller: 'ModalChangeBillingPeriodCtrl',
				windowClass: 'billing-period-modal',
				resolve: {
					license: () => ({admin: true, rootCartItemId: ci.id, rootCartId: $scope.order.id, productName: ci.name, billingPeriod: ci.billingPeriod, maxReleaseDate}),
				}
			}).result.then(async function () {
				const data = await api.get('api/admin/orders', {params: {cartId: $scope.order.id}});
				$scope.order = data[0];
				fetchMirrorSyncCapabilities();
				fetchEmailBlocks();
				toastr.success('This license will be billed ' + $scope.billingPeriodLabel().toLowerCase() + ' starting at its next renewal.', 'Billing Period Changed');
				$scope.$applyAsync();
			}, angular.noop);
		};

		/**
		 * How each blocked address on this order is blocked, keyed by lowercased address.
		 * @type {Object<string, 'SOFT'|'HARD'>}
		 */
		let emailBlocks = {};

		/**
		 * @return {'SOFT'|'HARD'|undefined}
		 */
		$scope.emailBlock = (email) => email ? emailBlocks[email.trim().toLowerCase()] : undefined;

		function fetchEmailBlocks() {
			emailBlocks = {};
			const emails = ($scope.order.paymentDatas || [])
				.flatMap(pd => [pd.person?.email, pd.person?.emailAdditional])
				.filter(Boolean);
			if (!emails.length) {
				return;
			}
			api.adminFetchEmailBlocks(emails).then(blocks => {
				Object.entries(blocks).forEach(([email, block]) => emailBlocks[email.toLowerCase()] = block);
			});
		}

		fetchEmailBlocks();

		let didAddSupportNote = false;

		function fetchMirrorSyncCapabilities() {
			$scope.order.cartItems
				.flatMap(ci => ci.supports || [])
				.filter(support => support.productId === 57)
				.forEach(support => {
					api.getCapabilities({supportId: support.id})
						.then(caps => {
							support.capabilities = caps;
						});
				});

			const regex = /^(?:(?<timestamp>\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}Z?|[A-Za-z]{3} \d{1,2}, \d{4} \d{1,2}:\d{2}:\d{2} [AP]M|\d{1,2}\/\d{1,2}\/\d{2,4}, \d{1,2}:\d{2} [AP]M)\s+)?(?:User\s+(?<user>[\w.]+@[\w.-]+)\s+)?(?<message>[\s\S]*)$/;

			const unparsedNotes = $scope.order.cartItems
				.flatMap(ci => ci.supports || [])
				.map(support => support.notes || '')
				.flatMap(s => s.split('\n\n'));

			const parsedNotes = [...new Set(unparsedNotes).values()]
				.map(s => s.trim())
				.filter(Boolean)
				.map(text => {
					const match = text.match(regex);
					const {timestamp, user, message} = match.groups;
					let parsedTimestamp;

					if (timestamp) { // Only try to parse if a timestamp was actually found
						try {
							parsedTimestamp = storeUtils.parseDateFlexible(timestamp);
						} catch (e) {
							console.warn('Un-parseable timestamp ' + timestamp + ' in', text);
						}
					}

					return {
						message: message.trim(),
						user: user || null,
						timestamp: timestamp || null,
						parsedTimestamp: parsedTimestamp
					};
				});

			// --- FIX 2: Correct the property name in the sort function and make it more robust ---
			$scope.supportNotes = parsedNotes.sort((a, b) => {
				if (!a.parsedTimestamp) return 1;
				if (!b.parsedTimestamp) return -1;
				return a.parsedTimestamp - b.parsedTimestamp;
			});

			$scope.userSwitchUserToEmail = async function (email) {
				let u = await api.adminFetchUserByEmail(email);
				await session.switchUser({userId: u.id})
				$scope.$close();
				$location.path('/my-licenses')
			};

		}

		fetchMirrorSyncCapabilities();

		api.get('api/admin/products').then(response => {
			const cutoff = Date.now() - 86400000 * 30;
			// $scope.productsAll = response;
			$scope.products = response.filter(p => p.featuredBoolean || p.dateCreated > cutoff || p.dateModified > cutoff || p.id === $scope.order?.cartItems?.[0]?.supports?.[0]?.productId);
		})

		api.get('api/admin/variant-types').then(response => {
			$scope.variantTypes = response;
			$scope.variantTypesExcludingDups = response.filter(vt => !(vt.byteValue === 0 && vt.code === 'RENEWAL')); // filter out renewal, which shares a byteValue
		});

		$scope.addSupportNote = (/**Support*/ s) => {
			let note = window.prompt('Enter your note');
			if (!note) {
				return;
			}
			let date = new Date();
			let now = date.toISOString();
			now = now.substring(0, now.indexOf('.')) + 'Z'; // not interested in milliss
			s.notes += ('\n\n' + now + ' User ' + user.email + ' ' + note);
			let textarea = document.getElementById('support-note');
			textarea?.focus();
			textarea.scroll(0, 9999);
			didAddSupportNote = true;
			$scope.supportNotes.push({parsedTimestamp: date, message: note, user: user.email })
		}

		$scope.save = function () {
			if (!didAddSupportNote && $scope.supportNotes?.length) {
				if (!window.confirm('You should add a note before saving. You sure you want to submit this low-effort change?')) {
					return false;
				}
			}
			api.saveOrder($scope.order)
				.then(function (response) {
					angular.copy(response, $scope.originalOrder);
					$scope.$close($scope.order);
					toastr.success('Your changes have been saved');
				});
		};

		$scope.editCartItemId = async function (cartItemId) {
			const data = await api.get('api/admin/orders', {params: {cartItemId: cartItemId}});
			if (!data.length) {
				window.alert('No order found for cartItemId ' + cartItemId);
				return;
			}
			$scope.order = $scope.originalOrder = data[0];
			$scope.order.cartItems[0].rootCartItem = await api.get('api/admin/root-cart-item', {params: {cartItemId}});
			fetchMirrorSyncCapabilities();
			fetchEmailBlocks();
		};

		$scope.addSupportRecord = async function (cartItem) {
			if (!cartItem.supports) {
				cartItem.supports = [];
			}
			let support = await api.adminGenerateSupportStub(cartItem.id);
			cartItem.supports.push(support);
		};

		$scope.fetchEmails = async () => {
			$scope.emails = 'Fetching';
			$scope.emails = await api.adminFetchEmails($scope.order.id);
		};
		$scope.fetchLicenseCheckActivity = async () => {
			$scope.licenseCheckActitivies = 'Fetching';
			$scope.licenseCheckActitivies = await api.adminFetchLicenseCheckActivities($scope.order.id);
		};


		$scope.authorizeSearchUrl = (params) => {
			return 'https://account.authorize.net/UI/themes/anet/merch.aspx?page=search&StartBatch=958879601&EndBatch=815319589&' + params;
		};

		$scope.cardPointeTransactionUrl = (transactionId) => {
			return 'https://cardpointe.cardconnect.com/account/#/reporting/transactiondetail/496141382887/R' + transactionId;
		};
		$scope.cardPointeProfileUrl = (accountId) => {
			return 'https://cardpointe.cardconnect.com/account/#/contacts/contactdetail/' + accountId + '/0';
		};

	})
	.controller('PromoEditCtrl', function ($scope, api, promo) {
		$scope.originalPromo = promo;
		$scope.promo = angular.copy(promo);
		$scope.save = function () {
			if (!$scope.promo.variant) {
				$scope.promo.variant = null;
			}
			api.savePromoCode($scope.promo)
				.then(function (response) {
					angular.copy(response, $scope.originalPromo);
					$scope.$close($scope.promo);
					toastr.success('Your changes have been saved');
				});
		};

		$scope.quickSearchVariants = function (q) {
			return api.get('api/quicksearch-variant', {params: {q: q}});
		};

	}).directive('proscTableData', function () {
	function beautify(s) {
		// add a space between (lowercase) and (uppercase + lowercase)
		if (s === 'id') {
			return 'ID';
		}
		return s.substr(0, 1).toUpperCase() +
			s.substr(1)
				.replace(/_([a-z])/, function (x, m) {
					return ' ' + m.toUpperCase();
				})
				.replace(/([a-z])([A-Z][a-z])/g, '$1 $2');
	}

	return {
		template: '<table class="table table-sm table-striped">' +
			'<thead><tr><th ng-repeat="c in columns">{{c.name}}</th></tr></thead>' +
			'<tbody><tr ng-repeat="o in rows">' +
			'<td ng-repeat="c in columns">{{o[c.key]}}</td>' +
			'</tr></tbody>' +
			'</table>        ',
		restrict: 'A',
		scope: {
			proscTableData: '=',
		},
		link: function (scope) {
			scope.$watch('proscTableData', function () {
				if (!scope.proscTableData || scope.proscTableData.length === 0) {
					// nothing bound yet, or it's been reset/cleared
					scope.rows = scope.columns = null;
				} else if (scope.proscTableData.rows) {
					// this is JDBCQueryData
					scope.rows = scope.proscTableData.rows;
					scope.columns = scope.proscTableData.columnNames.map(function (s) {
						return {key: s, name: beautify(s)};
					});
				} else if (scope.proscTableData.length) {
					// array of objects
					scope.columns = Object.keys(scope.proscTableData[0]).map(function (o) {
						return {key: o, name: beautify(o)};
					});
					scope.rows = scope.proscTableData;
				} else {
					console.warn('Wrong data type fo proscTableData, expected array of objects or JDBCHelper query data');
					scope.rows = null;
					scope.columns = null;
				}
			});
		},
		controller: function () {
		}

	};
});
